import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import Loader from "../../../shared/Loader/Loader"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { useSelector } from "react-redux"
import UpdateReduxDropDownCodes from "../../../shared/UpdateReduxDropDownCodes"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewPOS = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'POS')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'POS')?.IsDeleted
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        POSCodeVal: "",
    }

    let POS_Modal = {
        // PracticeID: 113,
        POSCode: null,
        Description: "",
        FullDescription: "",
        UpdatedDate: "",
        UpdatedBy: ""
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    const [POSCodes, setPOSCodes] = useState()
    const [POSValidationModal, setPOSValidationModal] = useState(ValidationModal)
    const [POSSaveUpdateModal, setPOSSaveUpdateModal] = useState({})
    const [mainPOSModal, setmainPOSModal] = useState(POS_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenPOS, onClose, onDeletePOS, type } = { ...props }
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [onPOSsave, setOnPOSsave] = useState(false)
    useEffect(() => {
        if (props.POSCode != null) {
            setPOSCodes(props.POSCode)
            setDel(true)
        } else {
            if (!onPOSsave) {
                setPOSCodes(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(POSCodes) && POSCodes !== '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": POSCodes,
                "TableName": enumUtil.enumAPITableName.POS
            }).then((response) => {
                setIsLoading(false)
                setmainPOSModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [POSCodes])



    const handlePOSChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainPOSModal };
        let saveModal = { ...POSSaveUpdateModal }
        modal[name] = value
        setmainPOSModal(modal)
        for (var property in POS_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPOSSaveUpdateModal(saveModal)
    }
    const POSValidation = async () => {
        let ValidationModal = {
            POSCodeVal: FormValidator(
                mainPOSModal.POSCode,
                enumUtil.enumValidationType.Required,
                'POS Code',
            )
        }
        await setPOSValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSavePOS = async () => {
        await POSValidation()
        setPOSCodes(mainPOSModal.POSCode)
        setPOSCodes(POSCodes)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setPOSSaveUpdateModal(POSSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.POS,
                ID: POSCodes,
                data: { ...POSSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        console.log(DropDowns.POS);
                        UpdateReduxDropDownCodes(POSCodes, DropDowns.POS, response.id, mainPOSModal.POSCode + ' - ' + mainPOSModal.Description, mainPOSModal.POSCode)

                        // if (POSCodes === null) {
                        //     let obj = { value: response.value, display:  response.value + ' - ' + mainPOSModal.Description }
                        //     DropDowns.POS.push(obj)
                        // }
                        console.log(DropDowns.POS);
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setPOSCodes(response.id)
                        setOnPOSsave(true)
                        onDeletePOS()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    if (!isNull(error.response.data)) { NotificationHandler(error.response.data, enumUtil.enumtoaster.error) }
                    else { NotificationHandler(error.response.data, enumUtil.enumtoaster.error) }
                })
        }
    }
    const SetPOSName = () => {
        if (mainPOSModal.POSCode != null && mainPOSModal.POSCode != "") {
            return (
                <p className="heading">{mainPOSModal.POSCode}</p>
            )
        } else {
            return (
                <p className="heading">Add New POS Code</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button  className= {IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.POS} ID={POSCodes} onClose={onDeletePOS} dropDown={DropDowns.POS} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={POSCodes + ""} TableName={enumUtil.enumAPITableName.POS} />
    }
    const AddNewPOSModalBody = () => {
        return (
            <>
                <div className="">
                    <div className="form-group input">
                        <label htmlFor="POSCode">POS Code<span className='req'>*</span></label>
                        <div className={POSValidationModal.POSCodeVal ? 'form-group input error' : 'form-group input'}>
                            <input type="text"
                                className='form-control'
                                name="POSCode"
                                id="POSCode"
                                autoComplete="off"
                                value={mainPOSModal.POSCode}
                                maxLength={2}
                                onChange={handlePOSChange}
                            />
                            {POSValidationModal.POSCodeVal}
                        </div>
                        {/* {/ error helperText="Error Message" /} */}
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <input type="text"
                            className='form-control'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainPOSModal.Description}
                            onChange={handlePOSChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="FullDescription">Full Description</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control'
                            name="FullDescription"
                            id="FullDescription"
                            value={mainPOSModal.FullDescription}
                            onChange={handlePOSChange}
                        />
                    </div>
                </div>
            </>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15 px-10">
                        {AddNewPOSModalBody()}
                    </div>
                    <ModalFooter isSaved={onPOSsave ? onDeletePOS : onClose} handleSave={handleSavePOS} UpdatedDate={mainPOSModal.UpdatedDate} UpdatedBy={mainPOSModal.UpdatedBy} ID={POSCodes} IsEditAllowed={IsEditAllowed}/>
                </> :
                <Modal show={isOpenPOS} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                      {isLoading ? <Loader /> : null}
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetPOSName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onPOSsave ? onDeletePOS : onClose} key={631} Name={'POS'} IsDeleteAllowed={IsDeleteAllowed} />
                        {/* {isLoading ? <Loader /> : null} */}
                        {AddNewPOSModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onPOSsave ? onDeletePOS : onClose} handleSave={handleSavePOS} UpdatedDate={mainPOSModal.UpdatedDate} UpdatedBy={mainPOSModal.UpdatedBy} ID={POSCodes} IsEditAllowed={IsEditAllowed}/>
                </Modal>
            }

        </React.Fragment>

    )
}

export default AddNewPOS